import { render, staticRenderFns } from "./ok-header.vue?vue&type=template&id=b02af45c&scoped=true"
import script from "./ok-header.vue?vue&type=script&lang=js"
export * from "./ok-header.vue?vue&type=script&lang=js"
import style0 from "./ok-header.vue?vue&type=style&index=0&id=b02af45c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02af45c",
  null
  
)

export default component.exports